import React from 'react';
import { Box, Typography } from '@mui/material';
import { PlatformOrganisationDto } from '../../api/platformApi';
import { PlatformOrganisationListItem } from '../molecules/PlatformOrganisationListItem';
import { ListViewShell } from '../../../../shared/components/ui/ListViewShell';

interface PlatformOrganisationsListViewProps {
  organisations: PlatformOrganisationDto[];
  loading: boolean;
}

export const PlatformOrganisationsListView: React.FC<
  PlatformOrganisationsListViewProps
> = ({ organisations, loading }) => {
  return (
    <ListViewShell
      itemCount={organisations.length}
      loading={loading}
      emptyMessage="No organisations found"
      data-testid="platform-organisations-list"
      columnHeaders={
        <>
          <Typography variant="caption" color="text.secondary" sx={{ flex: 1 }}>
            Name
          </Typography>
          <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              alignItems: 'center',
              gap: 2,
              flexShrink: 0,
            }}
          >
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ width: 240 }}
            >
              Owner
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ width: 100 }}
            >
              Created
            </Typography>
          </Box>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ width: 90, textAlign: 'right' }}
          >
            Status
          </Typography>
        </>
      }
    >
      {organisations.map(org => (
        <PlatformOrganisationListItem key={org.id} organisation={org} />
      ))}
    </ListViewShell>
  );
};
